
import { defineComponent } from "vue";
import {
  getEojBlackIcon
} from "@/utils/resource-util";
export default defineComponent({
  name: "SearchApplianceIconItem",
  props: {
    /**
     * eoj
     */
    eoj: {
      type: String,
      required: true
    }
  },
  setup(props) {
    const getIcon = () => {
      return getEojBlackIcon(props.eoj);
    };
    return {
      getIcon
    };
  }
});
